module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/club-events.json
// module id = 393
// module chunks = 10681889306463